import React from 'react';
import PropTypes from 'prop-types';
import AutocompleteField from './AutocompleteField';

import CustomerService from 'services/CustomerService';

function CustomerAutocompleteExceptForIdField({ getSuggestionLabel, exceptForIds, ...others }) {
  const handleSearchTerm = (inputValue, setIsLoading) => {
    setIsLoading(true);
    return CustomerService.searchExceptForId(inputValue, exceptForIds)
      .then((data) => {
        return data;
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <AutocompleteField
      onChangeSearchTerm={handleSearchTerm}
      getSuggestionLabel={getSuggestionLabel}
      placeholder="Selectione..."
      {...others}
    />
  );
}

CustomerAutocompleteExceptForIdField.defaultProps = {
  getSuggestionLabel: (object) => {
    return object.name;
  },
  onChange: () => {},
};
CustomerAutocompleteExceptForIdField.propTypes = {
  getSuggestionLabel: PropTypes.func,
  onChange: PropTypes.func,
};
export default CustomerAutocompleteExceptForIdField;
